/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDeliverFeeKrAmountlListRespVo
 */
export interface GetDeliverFeeKrAmountlListRespVo {
    /**
     * 数据id
     * @type {number}
     * @memberof GetDeliverFeeKrAmountlListRespVo
     */
    id?: number;
    /**
     * 起始值  三边合 单位cm
     * @type {number}
     * @memberof GetDeliverFeeKrAmountlListRespVo
     */
    beginValueCm?: number;
    /**
     * 结束值  三边合 单位cm
     * @type {number}
     * @memberof GetDeliverFeeKrAmountlListRespVo
     */
    endValueCm?: number;
    /**
     * 起始值 重量 单位kg
     * @type {number}
     * @memberof GetDeliverFeeKrAmountlListRespVo
     */
    beginValueKg?: number;
    /**
     * 结束值 重量 单位kg
     * @type {number}
     * @memberof GetDeliverFeeKrAmountlListRespVo
     */
    endValueKg?: number;
    /**
     * 金额
     * @type {number}
     * @memberof GetDeliverFeeKrAmountlListRespVo
     */
    amount?: number;
}

/**
 * Check if a given object implements the GetDeliverFeeKrAmountlListRespVo interface.
 */
export function instanceOfGetDeliverFeeKrAmountlListRespVo(value: object): value is GetDeliverFeeKrAmountlListRespVo {
    return true;
}

export function GetDeliverFeeKrAmountlListRespVoFromJSON(json: any): GetDeliverFeeKrAmountlListRespVo {
    return GetDeliverFeeKrAmountlListRespVoFromJSONTyped(json, false);
}

export function GetDeliverFeeKrAmountlListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliverFeeKrAmountlListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'beginValueCm': json['beginValueCm'] == null ? undefined : json['beginValueCm'],
        'endValueCm': json['endValueCm'] == null ? undefined : json['endValueCm'],
        'beginValueKg': json['beginValueKg'] == null ? undefined : json['beginValueKg'],
        'endValueKg': json['endValueKg'] == null ? undefined : json['endValueKg'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function GetDeliverFeeKrAmountlListRespVoToJSON(json: any): GetDeliverFeeKrAmountlListRespVo {
    return GetDeliverFeeKrAmountlListRespVoToJSONTyped(json, false);
}

export function GetDeliverFeeKrAmountlListRespVoToJSONTyped(value?: GetDeliverFeeKrAmountlListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'beginValueCm': value['beginValueCm'],
        'endValueCm': value['endValueCm'],
        'beginValueKg': value['beginValueKg'],
        'endValueKg': value['endValueKg'],
        'amount': value['amount'],
    };
}

